import { PageLayout } from '../components/page-layout';
import { CustomerColors } from '../components/customer-colors';

import { try_get_querystring_value } from '../querystring';
import {
    PAGE_NOT_FOUND,
    THE_PAGE_YOU_ARE_LOOKING_FOR_DOES_NOT_EXIST,
} from '../translator/phrase-keys';
import { useContext } from 'react';
import { LanguageContext } from '../components/language-settings';

export function NotFoundPage() {
    const {translator} = useContext(LanguageContext);
    return (<>
        <PageLayout
            image="svg/not-found.svg"
            title={translator.translate(PAGE_NOT_FOUND)}
            description={translator.translate(THE_PAGE_YOU_ARE_LOOKING_FOR_DOES_NOT_EXIST)}>
            <a className="page-link" href={customerStartpageLink()}>Startpage</a>
        </PageLayout>
        <CustomerColors />
    </>);
}

function customerStartpageLink() {
    const [hasCustomerId, customerId] = try_get_querystring_value("customer");
    if (hasCustomerId) {
        return `/?customer=${customerId}`;
    }

    return `/`;
}